import React from 'react';

/**
 * Cute hand-drawn otter avatar for the Feedback module.
 * Pure SVG — no external assets. Animates a small wave when hovered/clicked.
 */
const OtterAvatar = ({ size = 48, animate = false, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    className={`${className} ${animate ? 'otter-bounce' : ''}`}
    aria-label="Loutre mascotte"
  >
    <defs>
      <radialGradient id="otterBody" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#a86b3f" />
        <stop offset="100%" stopColor="#7a4a26" />
      </radialGradient>
      <radialGradient id="otterBelly" cx="50%" cy="50%" r="60%">
        <stop offset="0%" stopColor="#f5d8b0" />
        <stop offset="100%" stopColor="#e0bf91" />
      </radialGradient>
    </defs>

    {/* Body */}
    <ellipse cx="50" cy="62" rx="32" ry="30" fill="url(#otterBody)" />

    {/* Belly */}
    <ellipse cx="50" cy="68" rx="20" ry="18" fill="url(#otterBelly)" />

    {/* Left ear */}
    <ellipse cx="28" cy="32" rx="7" ry="6" fill="#7a4a26" />
    <ellipse cx="28" cy="32" rx="3.5" ry="3" fill="#f5d8b0" />

    {/* Right ear */}
    <ellipse cx="72" cy="32" rx="7" ry="6" fill="#7a4a26" />
    <ellipse cx="72" cy="32" rx="3.5" ry="3" fill="#f5d8b0" />

    {/* Head */}
    <circle cx="50" cy="42" r="22" fill="url(#otterBody)" />

    {/* Face mask (lighter fur) */}
    <ellipse cx="50" cy="48" rx="15" ry="13" fill="#f5d8b0" />

    {/* Eyes */}
    <circle cx="42" cy="42" r="3.2" fill="#1a1a1a" />
    <circle cx="58" cy="42" r="3.2" fill="#1a1a1a" />
    <circle cx="43" cy="41" r="1.1" fill="#ffffff" />
    <circle cx="59" cy="41" r="1.1" fill="#ffffff" />

    {/* Nose */}
    <ellipse cx="50" cy="50" rx="2.5" ry="2" fill="#1a1a1a" />

    {/* Mouth (smile) */}
    <path d="M 46 54 Q 50 58 54 54" stroke="#1a1a1a" strokeWidth="1.5" fill="none" strokeLinecap="round" />

    {/* Whiskers */}
    <line x1="36" y1="51" x2="42" y2="52" stroke="#3a2418" strokeWidth="0.8" strokeLinecap="round" />
    <line x1="36" y1="53" x2="42" y2="53" stroke="#3a2418" strokeWidth="0.8" strokeLinecap="round" />
    <line x1="64" y1="51" x2="58" y2="52" stroke="#3a2418" strokeWidth="0.8" strokeLinecap="round" />
    <line x1="64" y1="53" x2="58" y2="53" stroke="#3a2418" strokeWidth="0.8" strokeLinecap="round" />

    {/* Little hand holding a tiny pencil */}
    <g transform="translate(70, 70) rotate(20)">
      <rect x="-4" y="-1.5" width="14" height="3" fill="#fbbf24" rx="0.5" />
      <polygon points="10,-1.5 14,0 10,1.5" fill="#1a1a1a" />
      <polygon points="-4,-1.5 -6,0 -4,1.5" fill="#ec4899" />
    </g>

    {/* Small paw bottom-left */}
    <ellipse cx="28" cy="85" rx="5" ry="3.5" fill="#5a3318" />
  </svg>
);

export default OtterAvatar;
